import Phaser from 'phaser';
import { ANIM_KEYS, TEXTURE_KEYS } from '../assets/assetKeys';
import { SaveSystem } from '../systems/SaveSystem';
import { UIStyle } from '../ui/UIStyle';

export class Player extends Phaser.Physics.Arcade.Sprite {
  private speed = 200;
  private facingRight = true;
  private movementEnabled = true;
  private nameLabel: Phaser.GameObjects.Text;
  private static readonly NAME_LABEL_GAP = 10;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, TEXTURE_KEYS.PLAYER_IDLE_0);

    this.setOrigin(0.5, 1);
    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.setCollideWorldBounds(true);
    this.setDepth(10);
    this.syncPhysicsBody();
    this.play(ANIM_KEYS.PLAYER_IDLE);

    const playerName = SaveSystem.getPlayerName();
    const labelY = y - this.displayHeight - Player.NAME_LABEL_GAP;
    this.nameLabel = scene.add.text(x, labelY, playerName, UIStyle.nameTag(14));
    this.nameLabel.setOrigin(0.5, 1);
    this.nameLabel.setDepth(11);
  }

  /** Hitbox di bagian kaki — selaras dengan origin bawah */
  private syncPhysicsBody(): void {
    const body = this.body as Phaser.Physics.Arcade.Body;
    if (!body) return;
    body.setSize(28, 36);
    body.setOffset(18, 44);
    body.setMaxVelocity(this.speed, this.speed);
    body.setCollideWorldBounds(true);
    body.updateFromGameObject();
  }

  move(direction: { x: number; y: number }, _delta: number): void {
    if (!this.movementEnabled) {
      this.halt();
      return;
    }

    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setVelocity(direction.x * this.speed, direction.y * this.speed);

    if (direction.x !== 0 || direction.y !== 0) {
      if (direction.x < 0) {
        this.facingRight = false;
        this.setFlipX(true);
      } else if (direction.x > 0) {
        this.facingRight = true;
        this.setFlipX(false);
      }
      if (!this.anims.isPlaying || this.anims.currentAnim?.key !== ANIM_KEYS.PLAYER_WALK) {
        this.anims.play(ANIM_KEYS.PLAYER_WALK, true);
      }
    }
  }

  halt(): void {
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setVelocity(0, 0);
    if (this.anims.currentAnim?.key !== ANIM_KEYS.PLAYER_IDLE) {
      this.anims.play(ANIM_KEYS.PLAYER_IDLE, true);
    }
  }

  setMovementEnabled(enabled: boolean): void {
    this.movementEnabled = enabled;
    if (!enabled) this.halt();
  }

  isMovementEnabled(): boolean {
    return this.movementEnabled;
  }

  setSpeed(speed: number): void {
    this.speed = speed;
    const body = this.body as Phaser.Physics.Arcade.Body;
    body?.setMaxVelocity(speed, speed);
  }

  isFacingRight(): boolean {
    return this.facingRight;
  }

  updateLabel(): void {
    this.nameLabel.setPosition(
      this.x,
      this.y - this.displayHeight - Player.NAME_LABEL_GAP,
    );
  }

  destroy(fromScene?: boolean): void {
    this.nameLabel.destroy();
    super.destroy(fromScene);
  }
}
